(() => {
  if (!window.__ECHELON_PARTNERS_CART_BOUND__) {
    window.__ECHELON_PARTNERS_CART_BOUND__ = true;
    document.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-add-to-cart][data-product-id]');
      if (!button || button.dataset.cartPending === 'true') return;
      const variantId = String(button.dataset.productId || '').trim();
      if (!variantId || button.classList.contains('out-of-stock')) return;
      event.preventDefault();
      event.stopPropagation();
      button.dataset.cartPending = 'true';
      const label = button.querySelector('span');
      button.disabled = true;
      if (label) label.textContent = 'Adding...';
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {'Content-Type': 'application/json', Accept: 'application/json'},
          body: JSON.stringify({items: [{id: Number(variantId), quantity: 1}]}),
        });
        if (!response.ok) throw new Error('cart_add_failed');
        window.location.assign('/cart');
      } catch (_) {
        button.disabled = false;
        delete button.dataset.cartPending;
        if (label) label.textContent = 'Add to cart';
      }
    }, true);
  }

  if (window.__ECHELON_PARTNERS_VERIFICATION_BOUND__) return;

  const select = document.getElementById('partner');
  const button = document.getElementById('verify');
  const login = document.getElementById('partner-login');
  const result = document.getElementById('result');
  const context = document.getElementById('partners-context');
  if (!select || !button || !result) return;

  const params = new URLSearchParams(window.location.search);
  const selectedPartner = params.get('partner');
  const authReturn = params.get('auth_return') === '1';
  const customerId = context?.dataset.customerId || '';
  let activeSession = '';
  let activeEmail = '';
  if (selectedPartner && [...select.options].some((option) => option.value === selectedPartner)) {
    select.value = selectedPartner;
  }

  const updateLoginLink = () => {
    if (login && select.value) {
      login.href = `/account/login?return_url=${encodeURIComponent(`/pages/partners?partner=${select.value}`)}`;
      login.hidden = true;
    }
  };

  const updateButtonState = () => {
    button.disabled = false;
    if (!select.value && !selectedPartner) {
      result.textContent = 'Select your organization to continue.';
    }
  };

  const openCustomerLogin = () => {
    const authUrl = `https://echelonoauth-rofezert.manus.space/customer-auth/start?partner=${encodeURIComponent(select.value)}`;
    const popup = window.open('about:blank', 'echelon-partner-login', 'popup,width=480,height=720');
    if (!popup) {
      if (login) {
        login.href = authUrl;
        login.textContent = 'Open secure sign-in';
        login.hidden = false;
      }
      result.textContent = 'Your browser blocked the sign-in popup. Tap “Open secure sign-in” to continue.';
      return;
    }
    popup.location.href = authUrl;
    result.textContent = 'Complete secure sign-in in the popup. This page will update automatically.';
    popup.focus();
  };

  const verify = async (session = activeSession) => {
    if (!select.value) {
      result.textContent = 'Choose an organization first.';
      return;
    }

    if (!session) {
      openCustomerLogin();
      return;
    }

    button.disabled = true;
    result.textContent = activeEmail ? `Signed in as ${activeEmail}. Checking your email domain...` : 'Checking your signed-in Shopify account and email domain...';

    try {
      const response = await fetch(`https://echelonoauth-rofezert.manus.space/customer-auth/benefit?partner=${encodeURIComponent(select.value)}`, {
        credentials: 'omit',
        headers: { Accept: 'application/json', Authorization: `Bearer ${session}` },
      });
      const data = await response.json();

      if (data.ok && data.discountCode) {
        result.textContent = 'Verified. Applying your one-time 10% partner benefit...';
        const cartReturn = encodeURIComponent('/cart?partners_discount=applied');
        window.location.assign(`/discount/${encodeURIComponent(data.discountCode)}?redirect=${cartReturn}`);
        return;
      }

      if (data.reasonCode === 'CUSTOMER_AND_PARTNER_REQUIRED') {
        result.textContent = 'Customer verification is required. Please try the verification button again.';
      } else if (data.reasonCode === 'DOMAIN_NOT_APPROVED') {
        result.textContent = 'The email domain on your Shopify account is not approved for the selected organization.';
      } else if (data.reasonCode === 'BENEFIT_ALREADY_ISSUED') {
        result.textContent = 'This customer account has already received the partner benefit.';
      } else if (data.reasonCode === 'BENEFIT_IN_PROGRESS') {
        result.textContent = 'Your partner benefit is already being prepared. Please try again shortly.';
      } else {
        result.textContent = `Verification could not be completed: ${data.reasonCode || 'unknown error'}`;
      }
    } catch (_) {
      result.textContent = 'Verification service unavailable. Try again shortly.';
    }

    button.disabled = false;
  };

  select.addEventListener('change', () => {
    updateLoginLink();
    updateButtonState();
  });
  select.addEventListener('input', () => {
    updateLoginLink();
    updateButtonState();
  });
  button.addEventListener('click', verify);
  window.addEventListener('message', (event) => {
    if (event.origin !== 'https://echelonoauth-rofezert.manus.space' || event.data?.type !== 'echelon-customer-auth-complete') return;
    if (event.data.partner && event.data.partner !== select.value) return;
    activeSession = event.data.session || '';
    activeEmail = event.data.email || '';
    if (activeSession) {
      if (login) login.hidden = true;
      result.textContent = event.data.email ? `Signed in as ${event.data.email}. Verifying your partner benefit...` : 'Signed in successfully. Verifying your partner benefit...';
      verify(activeSession);
    }
  });
  updateLoginLink();
  updateButtonState();
})();
